export const BULDING_LEASING_PATH = '/inmuebles/arriendo';
export const BULDING_SELLING_PATH = '/inmuebles/compra';
export const BULDING_PROJECT_PATH = '/proyectos';
